import { render, staticRenderFns } from "./DeviceAssigned.vue?vue&type=template&id=61c19e4e"
import script from "./DeviceAssigned.vue?vue&type=script&lang=js"
export * from "./DeviceAssigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports